import React, { memo, useCallback, useEffect, useMemo, useState } from "react";

import formatIndexNumber from "common/format-index-number";

import { enquiryStatusOptions } from "constants/enquiry-status-options";

import JobApplicationTableProps, { JobApplicationStatusDto } from "dto/components/pages/job-application/page-job-application-table-dto";

import AppPagination from "components/app-pagination";
import AppSelectInput from "components/app-select-input";

const JobApplicationTable: React.FC<JobApplicationTableProps> = ({ applicationData, onUpdateStatus, onHandlePageChange, fetching, paginationTable }) => {
	const startIndex = paginationTable.currentPage * paginationTable.tableSize;
	const [status, setStatus] = useState<JobApplicationStatusDto>(null);
	const isEmptyData = useMemo(() => applicationData.length === 0 && !fetching, [applicationData.length, fetching]);
	const [isReadyData, setIsReadyData] = useState<boolean>(fetching);

	//prettier-ignore
	const onHandleInputChange = useCallback((id: string, value: string) => {
		setStatus({id: id, status: value});
		setIsReadyData(false);
		
		onUpdateStatus({id: id, status: value});
	}, [onUpdateStatus]);

	useEffect(() => {
		if (!fetching) setIsReadyData(true);
	}, [fetching]);

	useEffect(() => {
		if (isReadyData) setStatus(null);
	}, [isReadyData]);

	return (
		<div className="app-job-application-table">
			<div className="application-table">
				<div className="application-table__wrapper">
					<table className="application-table__container">
						<thead className="application-table__header">
							<tr>
								<th className="application-table__th">No.</th>
								<th className="application-table__th">Name</th>
								<th className="application-table__th">Email</th>
								<th className="application-table__th">Phone No.</th>
								<th className="application-table__th">Role Type</th>
								<th className="application-table__th">Message</th>
								<th className="application-table__th">Status</th>
							</tr>
						</thead>

						<tbody className="application-table__content">
							{applicationData.map((application, index) => {
								return (
									<tr className="application-table__tr" key={application.id}>
										<td className="application-table__td">{formatIndexNumber(index + 1 + startIndex)}</td>

										<td className="application-table__td">{application.name}</td>

										<td className="application-table__td">{application.email}</td>

										<td className="application-table__td">{application.phone}</td>

										<td className="application-table__td">{application.jobTitle}</td>

										<td className="application-table__td">{application.message}</td>

										<td className="application-table__td">
											{/* prettier-ignore */}
											<AppSelectInput name="status" placeholder={application.status} value={status && status.id === application.id ? status?.status : application.status} onChange={(e) => onHandleInputChange(application.id, e.target.value)} options={enquiryStatusOptions} searchable={false} />
										</td>
									</tr>
								);
							})}

							{fetching && (
								<tr className="application-table__tr">
									<td className="application-table__message" colSpan={7}>
										Loading...
									</td>
								</tr>
							)}

							{isEmptyData && (
								<tr className="application-table__tr">
									<td className="application-table__message" colSpan={7}>
										No records found
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>

				{!isEmptyData && !fetching && (
					<AppPagination currentPage={paginationTable.currentPage} totalPages={paginationTable.totalPages} onPageChange={onHandlePageChange} numberOfElements={paginationTable.numberOfElements} />
				)}
			</div>
		</div>
	);
};

export default memo(JobApplicationTable);
